import React from 'react'
import styles from './FieldSet.module.scss'

const FieldSet = ({ legendText, children, className, ...rest }) => (
    <div
        className={`${styles.fieldset} ${className ? className : ''}`}
        {...rest}
    >
        <legend>{legendText}</legend>
        <div>{children}</div>
    </div>
)

export { FieldSet }
